import { alpha, createTheme } from "@mui/material/styles";
import { brk, fontStack } from "@/theme/tokens";

// The Broker Portal MUI theme, built only from the brk tokens (tokens.ts).
// Customer-grade density: 16px body and input text (no iOS zoom on focus),
// sentence-case buttons, no elevation on buttons, no Paper overlay.
export function createBrkTheme() {
  return createTheme({
    palette: {
      mode: "light",
      primary: {
        main: brk.accent,
        dark: brk["accent-strong"],
        contrastText: "#ffffff",
      },
      secondary: { main: brk["accent-strong"], contrastText: "#ffffff" },
      error: { main: brk.danger },
      text: { primary: brk.text, secondary: brk.dim },
      background: { default: brk.bg, paper: brk.panel },
      divider: brk.border,
      action: {
        hover: alpha(brk.accent, 0.06),
        selected: alpha(brk.accent, 0.1),
      },
    },
    shape: { borderRadius: 8 },
    typography: {
      fontFamily: fontStack,
      fontSize: 14,
      button: { textTransform: "none", fontWeight: 500 },
    },
    components: {
      MuiButtonBase: { defaultProps: { disableRipple: true } },
      MuiButton: { defaultProps: { disableElevation: true } },
      MuiPaper: { styleOverrides: { root: { backgroundImage: "none" } } },
      // A modal's backdrop is the brand ink, not MUI's pure black; a menu's
      // invisible backdrop stays invisible.
      MuiBackdrop: {
        styleOverrides: {
          root: {
            variants: [
              {
                props: { invisible: false },
                style: { backgroundColor: alpha(brk.ink, 0.5) },
              },
            ],
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: { textTransform: "none", fontWeight: 500, minHeight: 48 },
        },
      },
      MuiInputBase: { styleOverrides: { input: { fontSize: 16 } } },
      MuiOutlinedInput: {
        styleOverrides: { notchedOutline: { borderColor: brk.border } },
      },
    },
  });
}
